import React from 'react'
import "./SecondNav.css"
const SecondNav = () => {
  return (
    <div>
        <ul className='SecondNav'>
            <li className='active'>About</li>
            <li>Jobs</li>
            <li>Apprenticeships</li>
        </ul>
        <div className='navImg'>
            <div className='Ableton'>
            <h1>Ableton</h1>
            </div>
            
        </div>
    </div>
  )
}

export default SecondNav